import { useTranslation } from 'react-i18next';

import { LoyaltyCard } from './LoyaltyCard';
import { RecommendButton } from './RecommendButton';

interface ReferralHeroProps {
  whatsappLink: string;
}

/**
 * Referral hero: headline, value proposition, WhatsApp CTA and the loyalty card.
 *
 * Two columns on desktop (text left, card right); single stacked column on mobile with the
 * card below the CTA.
 *
 * @param {ReferralHeroProps} props - Component properties
 * @returns {React.ReactElement} The hero section
 */
export const ReferralHero = ({ whatsappLink }: ReferralHeroProps) => {
  const { t } = useTranslation('referral');

  return (
    <section className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12">
      <div className="flex flex-col gap-6">
        <h1 className="text-5xl font-extrabold leading-tight text-primary md:text-6xl">{t('hero.title')}</h1>

        <div className="flex flex-col gap-3">
          <p className="text-2xl font-semibold text-foreground">
            {t('hero.subtitlePrefix')} <span className="italic text-primary">{t('hero.subtitleHighlight')}</span>{' '}
            {t('hero.subtitleSuffix')}
          </p>
          <p className="max-w-md text-base text-muted-foreground">{t('hero.description')}</p>
        </div>

        <RecommendButton className="w-fit" href={whatsappLink} label={t('cta.recommend')} />
      </div>

      <div className="flex justify-center lg:justify-end">
        <LoyaltyCard />
      </div>
    </section>
  );
};
